import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API_URL from '../config';

const AdminDashboard = () => {
  const [products, setProducts] = useState([]);
  const [adminData, setAdminData] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editingProduct, setEditingProduct] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const navigate = useNavigate();
  
  const [form, setForm] = useState({ name: '', description: '', price: '', imageUrl: '', category: 'balls', stockQuantity: 10, featured: false, discount: 0 });

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const storedAdmin = localStorage.getItem('adminData');
    if (!token || !storedAdmin) {
      navigate('/admin/login');
      return;
    }
    const admin = JSON.parse(storedAdmin);
    setAdminData(admin);
    fetchProducts();
    setLoading(false);
  }, [navigate]);

  const fetchProducts = async () => {
    const res = await fetch(`${API_URL}/products`);
    setProducts(await res.json());
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    navigate('/admin/login');
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();
    const productData = { ...form, price: parseFloat(form.price), stockQuantity: parseInt(form.stockQuantity) };
    if (editingProduct) {
      await fetch(`${API_URL}/products/${editingProduct._id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(productData) });
    } else {
      await fetch(`${API_URL}/products`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(productData) });
    }
    setEditingProduct(null);
    setForm({ name: '', description: '', price: '', imageUrl: '', category: 'balls', stockQuantity: 10, featured: false, discount: 0 });
    setShowAddForm(false);
    fetchProducts();
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div><h1>🏌️ Admin Dashboard</h1><p>Welcome, {adminData?.fullName} ({adminData?.role === 'superadmin' ? '👑 Super Admin' : 'Admin'})</p></div>
        <button onClick={handleLogout} className="btn-logout">Logout</button>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <h2>Products</h2>
        <button onClick={() => { setEditingProduct(null); setForm({ name: '', description: '', price: '', imageUrl: '', category: 'balls', stockQuantity: 10, featured: false, discount: 0 }); setShowAddForm(true); }} className="btn-add-product" style={{ width: 'auto', marginBottom: '1rem' }}>+ Add Product</button>
        
        {showAddForm && (
          <div className="admin-form">
            <h2>{editingProduct ? 'Edit Product' : 'Add New Product'}</h2>
            <form onSubmit={handleProductSubmit}>
              <div className="form-group"><label>Name</label><input type="text" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required /></div>
              <div className="form-group"><label>Description</label><textarea value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} required /></div>
              <div className="form-row">
                <div className="form-group"><label>Price (₱)</label><input type="number" value={form.price} onChange={(e) => setForm({...form, price: e.target.value})} required /></div>
                <div className="form-group"><label>Stock Quantity</label><input type="number" value={form.stockQuantity} onChange={(e) => setForm({...form, stockQuantity: e.target.value})} required /></div>
              </div>
              <div className="form-group"><label>Image URL</label><input type="text" value={form.imageUrl} onChange={(e) => setForm({...form, imageUrl: e.target.value})} required /></div>
              <div className="form-group"><label>Category</label><select value={form.category} onChange={(e) => setForm({...form, category: e.target.value})}><option value="balls">Golf Balls</option><option value="apparel">Apparel</option><option value="accessories">Accessories</option></select></div>
              <div className="form-buttons">
                <button type="submit" className="btn-primary">{editingProduct ? 'Update' : 'Add'} Product</button>
                <button type="button" onClick={() => setShowAddForm(false)} className="btn-secondary">Cancel</button>
              </div>
            </form>
          </div>
        )}
        
        <div className="filters-bar">
          <div className="search-box"><input type="text" placeholder="🔍 Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} /></div>
          <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}><option value="all">All</option><option value="balls">Golf Balls</option><option value="apparel">Apparel</option><option value="accessories">Accessories</option></select>
        </div>
        
        <div className="admin-product-grid">
          {products.filter(p => p.name.toLowerCase().includes(searchTerm.toLowerCase()) && (categoryFilter === 'all' || p.category === categoryFilter)).map(product => (
            <div key={product._id} className="admin-product-card">
              <img src={product.imageUrl} alt={product.name} style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }} />
              <div><strong>{product.name}</strong><br />₱{product.price}<br />Stock: {product.stockQuantity}</div>
              <div>
                <button onClick={() => { setEditingProduct(product); setForm(product); setShowAddForm(true); }} className="btn-edit">Edit</button>
                <button onClick={async () => { if (window.confirm('Delete?')) { await fetch(`${API_URL}/products/${product._id}`, { method: 'DELETE' }); fetchProducts(); } }} className="btn-delete">Delete</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;